import * as actions from '../../actions/actionTypes';

const initialState = false;

export default function memberFetching(state = initialState, action) {
  switch (action.type) {
    case actions.SET_MEMBERS_FETCHING:
      return true;
    case actions.SET_MEMBERS:
      return false;
    case actions.SET_MEMBERS_ERROR:
      return false;
    default:
      return state;
  }
}
